import { render, staticRenderFns } from "./_alias.vue?vue&type=template&id=4d957720&scoped=true&name=product-sheet&"
import script from "./_alias.vue?vue&type=script&lang=js&"
export * from "./_alias.vue?vue&type=script&lang=js&"
import style0 from "./_alias.vue?vue&type=style&index=0&id=4d957720&lang=scss&scoped=true&"
import style1 from "./_alias.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d957720",
  null
  
)

/* custom blocks */
import block0 from "./_alias.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports